/**
 * @generated SignedSource<<5e093717f6f8c831ca59692b236b8361>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PricingGuidanceInfo_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"pricingGuidanceTracking_item">;
  readonly " $fragmentType": "PricingGuidanceInfo_item";
};
export type PricingGuidanceInfo_item$key = {
  readonly " $data"?: PricingGuidanceInfo_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PricingGuidanceInfo_item">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "amount",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PricingGuidanceInfo_item",
  "selections": [
    {
      "kind": "InlineDataFragmentSpread",
      "name": "pricingGuidanceTracking_item",
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "buyerId",
              "variableName": "userId"
            },
            {
              "kind": "Literal",
              "name": "isBuyerEstimateEnabled",
              "value": true
            },
            {
              "kind": "Variable",
              "name": "isTrade",
              "variableName": "isTrade"
            },
            {
              "kind": "Variable",
              "name": "priceBookName",
              "variableName": "priceBookName"
            },
            {
              "kind": "Variable",
              "name": "userCountryCode",
              "variableName": "userCountryCode"
            }
          ],
          "concreteType": "PricingGuidance",
          "kind": "LinkedField",
          "name": "pricingGuidance",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "FinancialAmount",
              "kind": "LinkedField",
              "name": "price",
              "plural": false,
              "selections": (v0/*: any*/),
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "FinancialAmount",
              "kind": "LinkedField",
              "name": "minAmount",
              "plural": false,
              "selections": (v0/*: any*/),
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "FinancialAmount",
              "kind": "LinkedField",
              "name": "maxAmount",
              "plural": false,
              "selections": (v0/*: any*/),
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "args": null,
      "argumentDefinitions": [
        {
          "kind": "RootArgument",
          "name": "isTrade"
        },
        {
          "kind": "RootArgument",
          "name": "priceBookName"
        },
        {
          "kind": "RootArgument",
          "name": "userCountryCode"
        },
        {
          "kind": "RootArgument",
          "name": "userId"
        }
      ]
    }
  ],
  "type": "Item",
  "abstractKey": null
};
})();

(node as any).hash = "85d5721779505b7e84807577ed7fac29";

export default node;
